var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Modal from "../../components/Modal";
import Toast from "../../components/Toast";
import * as React from "react";
import { Size, VoucherState } from "../../../services/voucher";
import { getImg } from "./utils";
import { isNotBlankArray } from "../../../utils/array";
import { getVoucherModalContent } from "./VoucherModal";
import VoucherOne from "./VoucherOne";
import VoucherThree from "./VoucherThree";
import VoucherTwo from "./VoucherTwo";
export default class MagicVoucher extends React.Component {
    constructor(props) {
        super(props);
        this.setWarnMsg = (message, delay = 3000, fn) => {
            if (this.state.warnMsg) {
                return;
            }
            this.setState({ warnMsg: message }, () => {
                setTimeout(() => {
                    this.setState({ warnMsg: "" }, () => {
                        if (fn) {
                            fn();
                        }
                    });
                }, delay);
            });
        };
        this.handleCanReceive = (result, voucher) => {
            const { callbackLogin } = this.props;
            if (result && result.code === 200) {
                Modal.info({
                    width: 350,
                    content: getVoucherModalContent(voucher),
                    footer: voucher.link ? undefined : null,
                    okText: "GO SHOPPING",
                    onOK: () => {
                        location.href = voucher.link || "";
                    },
                });
            }
            else if (result && result.code === 403) {
                if (callbackLogin) {
                    callbackLogin();
                }
            }
            else {
                this.setWarnMsg(result.message);
            }
            this.handleUpdateData();
        };
        this.handleUpdateData = () => {
            const { callbackData } = this.props;
            const { vouchers } = this.state;
            const vouchersId = vouchers.map(item => item.voucherId);
            return callbackData(vouchersId).then(result => {
                const newdata = result ? [...result] : [];
                const combined = [];
                newdata.forEach((item, index) => {
                    var _a;
                    const data = vouchers[index];
                    if (item.id === ((_a = vouchers[index]) === null || _a === void 0 ? void 0 : _a.voucherId)) {
                        Object.assign(data, Object.assign({}, item));
                    }
                    combined.push(data);
                });
                this.setState({ vouchers: (newdata === null || newdata === void 0 ? void 0 : newdata.length) > 0 ? [...combined] : [...vouchers] });
            });
        };
        this.onClaimVoucher = (voucher) => __awaiter(this, void 0, void 0, function* () {
            const { callback, onClickVoucherCb } = this.props;
            onClickVoucherCb && onClickVoucherCb(voucher);
            switch (voucher.voucherState) {
                case VoucherState.canReceive:
                    this.setWarnMsg("Voucher coming soon");
                    break;
                case VoucherState.Received:
                    callback(voucher).then(result => {
                        this.handleCanReceive(result, voucher);
                    });
                    break;
                case VoucherState.ComingSoon:
                    this.setWarnMsg("Voucher has been Fully Redeemed");
                    break;
                case VoucherState.RanOut:
                    if (voucher.link) {
                        window.open(voucher.link);
                        return;
                    }
                    if (voucher.remainCount === 0) {
                        this.setWarnMsg("Voucher has been Fully Redeemed");
                    }
                    else {
                        this.setWarnMsg("You have reached the voucher redemption limit");
                    }
                    break;
                case VoucherState.Expired:
                    this.setWarnMsg("Voucher has expired");
                    break;
                default:
            }
        });
        this.renderMVoucherCom = (nextItems, columnNum) => {
            const { online, positionId, callbackText, language, baseColor } = this.props;
            const defaultProps = Object.assign(Object.assign({}, this.props), { onClaimVoucher: this.onClaimVoucher, callbackText, vouchers: nextItems, online, mdId: positionId, icon: getImg(language), baseColor });
            switch (columnNum) {
                case Size.one:
                    return React.createElement(VoucherOne, Object.assign({}, defaultProps));
                case Size.two:
                    return React.createElement(VoucherTwo, Object.assign({}, defaultProps));
                case Size.three:
                    return React.createElement(VoucherThree, Object.assign({}, defaultProps));
                default:
                    return null;
            }
        };
        const { data } = this.props;
        this.state = {
            vouchers: data,
            warnMsg: "",
        };
        this.handleUpdateData();
    }
    render() {
        const { columnNum } = this.props;
        const { warnMsg, vouchers } = this.state;
        if (isNotBlankArray(vouchers)) {
            return (React.createElement(React.Fragment, null,
                this.renderMVoucherCom(vouchers, columnNum),
                warnMsg && React.createElement(Toast, { message: warnMsg })));
        }
        return null;
    }
}
